import { curry, groupBy } from 'ramda';

function hasChildren(node) {
    return (typeof node === 'object')
        && (typeof node.children !== 'undefined')
        && (node.children.length > 0);
}

const Tree = {
    map: curry((mapFn, node, expanded, filterCompetences = null) => {
        const newNode = mapFn(node, filterCompetences ? filterCompetences : expanded);
        if (!hasChildren(node)) {
            return newNode;
        }

        newNode.children = newNode.children.map(r => {
            let expandedItem = expanded && expanded.items && Object.keys(expanded.items).length ? expanded.items[r.id] : null;
            return Tree.map(mapFn, r, expandedItem, filterCompetences);
        });

        return newNode;
    }),
    mapFormat(node, expanded) {
        const res = {
            id: node.id,
            title: node.name_ru,
            isExpanded: !!expanded,
            isLeaf: false,
            data: {
                id: node.id,
                parent_id: node.parent_id,
                name_ru: node.name_ru,
                name_en: node.name_en,
                name_fr: node.name_fr,
                is_hidden: !!node.is_hidden,
                is_subgroup: !!!node.is_competence,
                is_competence: !!node.is_competence,
                is_skill: false,
                children_is_competence: !!node.children_is_competence,
            }
        };
        if (node.children.length === 0) {
            res.isDisabled = !node.is_supported;
        }
        if (node.children.length > 0) {
            res.children = node.children;
        }
        return res;
    },
    mapFilterFormat: curry((node, selectedCompetenceSet) => {
        let isChecked = selectedCompetenceSet.has(node.id);

        const res = {
            id: node.id,
            name_ru: node.name_ru,
            name_en: node.name_en,
            name_fr: node.name_fr,
            isCompetence: !!node.is_competence,
            isChecked: isChecked,
            isIndeterminate: false,
            children: [],
        };
        if (hasChildren(node)) {
            res.children = node.children;
        }
        return res;
    }),
    mapSkills: curry((skills, node) => {
        let res = JSON.parse(JSON.stringify(node));
        if (node.data.is_competence) {
            res.children = skills[res.id];
        }
        return res;
    }),
    groupSkills(skills) {
        const byId = groupBy((s) => s.data.competence_id)
        return byId(skills);
    },
    format(skill) {
        return {
            id: skill.id,
            title: skill.name_ru,
            isExpanded: false,
            isLeaf: true,
            data: {
                id: skill.id,
                competence_id: skill.competence_id,
                name_ru: skill.name_ru,
                name_en: skill.name_en,
                name_fr: skill.name_fr,
                is_hidden: !!skill.is_hidden,
                is_subgroup: false,
                is_competence: false,
                is_skill: true,
                children_is_competence: false,
            }
        };
    }
};

export default Tree;
